import { Container, Divider } from "@material-ui/core";
import { Add } from "@material-ui/icons";
import { Grid } from "@mui/material";
import axios from "axios";
import {
  ArrayChip,
  ButtonGroupTop,
  CustomTable,
  ModalError,
  ModalSuccess,
  ModalWarning,
  Page,
  PrimaryButton,
  PrimaryDeleteButton,
  PrimaryRestoreButton,
  SectionLabel,
} from "components";
import { HeaderTitle } from "layouts";
import { getTotalPage } from "lib";
import { useEffect, useState } from "react";
import { useHistory } from "react-router";
import { hardBaseUrl } from "services/urlConstant";
import { globalStyles } from "styles";
import { getErrors, wordCapitalize } from "utils";

function RoleUser() {
  const classes = globalStyles();
  const history = useHistory();
  const token = localStorage.getItem("token");
  const headers = {
    Authorization: "Bearer " + token,
  };
  const [loadingPage, setLoadingPage] = useState(false);
  const [dataTable, setDataTable] = useState([]);
  const [queryParams, setQueryParams] = useState({
    page: 1,
    per_page: 10,
    search: "",
    sort: "",
  });
  const [tableTotalPage, setTableTotalPage] = useState(1);

  const handleChangeQueryParams = (key, value) =>
    setQueryParams(state => ({
      ...state,
      ...(key !== "page" && { page: 1 }),
      [key]: value,
    }));
  const handleActivate = item => {
    const { is_active, name } = item;
    ModalWarning(
      `Are you sure to ${is_active ? "deactivate" : "restore"} role ${name} ?`,
      `${is_active ? "Deactivate" : "Restore"} Role`
    ).then(res => res?.isConfirmed && activateRole(item));
  };

  const getDataTable = async () => {
    try {
      setLoadingPage(true);
      const res = await axios.get(`${hardBaseUrl}/role`, {
        headers,
        params: queryParams,
      });
      const { data, meta } = res?.data;
      setDataTable(data || []);
      const pageCount = getTotalPage(meta?.total, queryParams?.size);
      setTableTotalPage(pageCount || 1);
    } catch (error) {
      ModalError(getErrors(error?.response));
    } finally {
      setLoadingPage(false);
    }
  };
  const activateRole = async item => {
    const { is_active, role_id } = item;
    try {
      await axios.put(
        `${hardBaseUrl}/role/${role_id}/status`,
        { is_active: !is_active },
        { headers }
      );
      ModalSuccess(
        `Successfully ${is_active ? "Deactivate" : "Restore"} Role`
      ).then(res => res?.isConfirmed && getDataTable());
    } catch (error) {
      ModalError(getErrors(error?.response));
    }
  };

  useEffect(() => {
    getDataTable();
  }, [queryParams]);

  return (
    <Page className={classes.root} title="User Role">
      <Container maxWidth={false}>
        <HeaderTitle title="Configuration" breadcrumbData={breadcrumbData} />
        <ButtonGroupTop />
        <Divider className={classes.flatDivider} />
        <Grid container justifyContent="space-between" my={2}>
          <Grid item>
            <SectionLabel
              title="User Role"
              subTitle="Display a list of a roles available in the MPIS application. Roles are made for needs of grouping users based on work functions"
            />
          </Grid>
          <Grid item>
            <PrimaryButton
              label="Add User Roles"
              onClick={() => history.push("/admin/konfigurasi/role-user/add")}
              startIcon={<Add />}
              size="large"
            />
          </Grid>
        </Grid>
        <CustomTable
          isLoading={loadingPage}
          columnTable={columnTable}
          data={dataTable}
          page={queryParams?.page}
          pageSize={queryParams?.per_page}
          pageCount={tableTotalPage}
          handleChangePage={(_, data) => handleChangeQueryParams("page", data)}
          handleChangePageSize={event =>
            handleChangeQueryParams("per_page", event?.target?.value)
          }
          isHaveAction
          handleEdit={item =>
            history.push(`/admin/konfigurasi/role-user/edit/${item?.role_id}`)
          }
          tooltipEdit="Edit"
          customAction={item =>
            item?.is_active ? (
              <PrimaryDeleteButton
                tooltipTitle="Deactivate"
                onClick={() => handleActivate(item)}
              />
            ) : (
              <PrimaryRestoreButton
                tooltipTitle="Resote"
                onClick={() => handleActivate(item)}
              />
            )
          }
        />
      </Container>
    </Page>
  );
}

const breadcrumbData = [
  {
    label: "Home",
    link: "/admin/dashboard",
  },
  {
    label: "Configuration",
    link: "/admin/konfigurasi/role-user",
  },
  {
    label: "User Role",
    active: true,
  },
];
const columnTable = [
  {
    name: "name",
    title: "Role Name",
  },
  {
    name: "type",
    title: "Role Type",
    renderText: type => wordCapitalize(type),
  },
  {
    name: "applications",
    title: "Access Type",
  },
  {
    name: "permissions",
    title: "Access Right",
    renderText: item => <ArrayChip list={item} />,
  },
];
export default RoleUser;
